import React from 'react';

import { Draggable } from 'react-beautiful-dnd';

export default function DraggableTr({
    children, id, index, ...restProps
}) {
    return (
        <Draggable
            draggableId={id}
            index={index}
        >
            {(provided, snapshot) => (
                <tr
                    ref={provided.innerRef}
                    {...restProps}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className={snapshot.isDragging ? 'dragged-item' : null}
                >
                    {children}
                </tr>
            )}
        </Draggable>
    );
}
